import React from "react"
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { iterateStringEnum } from "../../../../../lib/enums"
import { DateType } from "../supplierAcquiringReportsTypes"

export function SelectDateTypeFilter({
    dateType,
    setDateType,
}: {
    dateType: DateType
    setDateType: React.Dispatch<React.SetStateAction<DateType>>
}) {
    return (
        <FormControl sx={{ minWidth: "13rem" }}>
            <LocalizedStrict id="supplier-acquiring-fees-table-select-filter-on-label">
                <InputLabel id="supplier-acquiring-fees-table-select-filter">Filter on</InputLabel>
            </LocalizedStrict>
            <LocalizedStrict id="supplier-acquiring-fees-table-select-filter-on-label-label" attrs={{ label: true }}>
                <Select
                    labelId="supplier-acquiring-fees-table-select-filter"
                    id="supplier-acquiring-fees-table-select-filter-on"
                    value={dateType}
                    label="Filter on"
                    onChange={(e) => setDateType(e.target.value as DateType)}
                >
                    {[...iterateStringEnum(DateType)].map((value) => (
                        <MenuItem key={value} value={value}>
                            <LocalizedEnum base="supplier-acquiring-fees-table-select-filter-on-item" enumValue={value}>
                                <span>{value}</span>
                            </LocalizedEnum>
                        </MenuItem>
                    ))}
                </Select>
            </LocalizedStrict>
        </FormControl>
    )
}
